import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/headshots/david-shannon.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Photo of David Shannon"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "David Shannon"),
  /*#__PURE__*/_createElementVNode("h3", null, "Partner | Assembly Capital Partners"),
  /*#__PURE__*/_createElementVNode("p", null, "David is a Partner at Assembly Capital Partners which is a specialist FinTech venture capital investor. David has over twenty five years experience of trading, risk management and private investment. He has run investment bank trading businesses across a range of asset classes on both a regional and global basis, including ten years based in Tokyo, Hong Kong and Singapore. He set up the Asian office of a large established hedge fund. Most recently in banking he was Head of Market Risk at a leading investment bank. David holds an MEng in Manufacturing Science and Engineering.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile = _resolveComponent("profile")!

  return (_openBlock(), _createBlock(_component_profile, null, {
    headshot: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}